import React from 'react';
import { Box, Grid } from '@mui/material';
import pro1 from '../../../images/pro1.jpg';
import pro2 from '../../../images/pro2.jpg';
import pro3 from '../../../images/pro3.jpg';

const Business = () => {
    return (
        <Box>
            <Grid container spacing={4}>

                <Grid item xs={12} sm={6} md={4}>
                    <Box className='projectCon'>
                        <Box sx={{ height: '280px', overflow: 'hidden', border: '2px solid #ddd', borderRadius: '8px' }} >
                            <img src={pro3} className='projectImg' alt="" />
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Box className='projectCon'>
                        <Box sx={{ height: '280px', overflow: 'hidden', border: '2px solid #ddd', borderRadius: '8px' }} >
                            <img src={pro2} className='projectImg' alt="" />
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>

                    <Box sx={{ height: '280px', overflow: 'hidden', border: '2px solid #ddd', borderRadius: '8px' }} >
                        <img src={pro1} className='projectImg' alt="" />
                    </Box>

                </Grid>

            </Grid>
        </Box>
    );
};

export default Business;